import { useState } from 'react';
import { Col, Grid, Row } from 'antd';
import { useActivityReport } from '@/hooks/app';
import { CalendarDate, DeviceWrapper, InputCalendar, PageContainer } from '@/components';
import { ActivityReportDesktop, ActivityReportMobile } from '../reserve/ActivityReport';
import { getEndOfCurrentMonth, getStartOfCurrentMonth } from '@/utils/date';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export function ActivityReportPage() {

  const [t] = useTranslation(['common']);
  const { lg } = Grid.useBreakpoint();
  const activityLogs = useActivityReport();
  const start = getStartOfCurrentMonth();
  const end = getEndOfCurrentMonth();

  const [fromDate, setFromDate] = useState(start.str);
  const [toDate, setToDate] = useState(end.str);

  return (
    <PageContainer noPadding bodyClassName="h-full" title={t('common:labels.activity-report')}>
      <Row
        className={
          classNames('w-full',
            lg ? 'mt-2 !mx-auto' : 'mt-3 !mx-0'
          )
        }
        gutter={[16, 16]}
      >
        <Col xxl={4} xl={6} lg={8} span={12}>
          <InputCalendar
            size="large"
            value={fromDate}
            defaultDate={start.date as any}
            className="text-center"
            placeholder={t('common:labels.start-date')}
            onChange={(d: CalendarDate) => setFromDate(d.strEn)}
          />
        </Col>
        <Col xxl={4} xl={6} lg={8} span={12}>
          <InputCalendar
            size="large"
            value={toDate}
            defaultDate={end.date as any}
            className="text-center"
            placeholder={t('common:labels.end-date')}
            onChange={(d: CalendarDate) => setToDate(d.strEn)}
          />
        </Col>
      </Row>
      <DeviceWrapper show={['desktop']}>
        <ActivityReportDesktop {...activityLogs} fromDate={fromDate} toDate={toDate} />
      </DeviceWrapper>
      <DeviceWrapper show={['mobile']}>
        <ActivityReportMobile {...activityLogs} fromDate={fromDate} toDate={toDate} />
      </DeviceWrapper>
    </PageContainer>
  );
}

export default ActivityReportPage;
